<cv-tab-group>
	<cv-tab [active]="true" [title]="'Message'">
		<cv-collapse>
			<cv-panel [class]="'dark'" [isExpandable]="false" [rightButtons]="copyMessage">
				<ace-editor
					#markupEditor
					[(text)]="messageInformation"
					[readOnly]="true"
					[mode]="'json'"
					[ngStyle]="{
						height: '500px',
						width: '100%'
					}"
				>
				</ace-editor>
			</cv-panel>
		</cv-collapse>
	</cv-tab>
	<cv-tab [title]="'Request'">
		<cv-collapse>
			<cv-panel [class]="'dark'" [isExpandable]="false" [rightButtons]="copyRequest">
				<ace-editor
					#markupEditor1
					[(text)]="requestInformation"
					[readOnly]="true"
					[mode]="'json'"
					[ngStyle]="{
						height: '500px',
						width: '100%'
					}"
				>
				</ace-editor>
			</cv-panel>
		</cv-collapse>
	</cv-tab>
	<cv-tab [title]="'Response'">
		<cv-collapse>
			<cv-panel [class]="'dark'" [isExpandable]="false" [rightButtons]="copyResponse">
				<ace-editor
					#markupEditor2
					[(text)]="responseInformation"
					[readOnly]="true"
					[mode]="'json'"
					[ngStyle]="{
						height: '500px',
						width: '100%'
					}"
				>
				</ace-editor>
			</cv-panel>
		</cv-collapse>
	</cv-tab>
	<cv-tab [title]="'Error'">
		<cv-collapse>
			<cv-panel [class]="'dark'" [isExpandable]="false" [rightButtons]="copyError">
				<ace-editor
					#markupEditor3
					[(text)]="errorInformation"
					[readOnly]="true"
					[mode]="'json'"
					[ngStyle]="{
						height: '500px',
						width: '100%'
					}"
				>
				</ace-editor>
			</cv-panel>
		</cv-collapse>
	</cv-tab>
</cv-tab-group>
